// extracted by mini-css-extract-plugin
module.exports = {"reporting":"btqr2","message":"s3FWe","loader":"TOpz5"};